import { render, staticRenderFns } from "./CustomerSummary.vue?vue&type=template&id=7e4fdebd&scoped=true&"
import script from "./CustomerSummary.vue?vue&type=script&lang=js&"
export * from "./CustomerSummary.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSummary.vue?vue&type=style&index=0&id=7e4fdebd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4fdebd",
  null
  
)

export default component.exports